import {Card, CardBody} from "reactstrap"
import SurveyGrid from "@src/views/rds/surveys/SurveyGrid"

// Sidebar page: all S2B paid surveys available to this RD
const RdSurveys = () => {
    return (
        <div>
            <h2 className="mb-50">Paid Surveys</h2>
            <p className="text-muted mb-2">Share your expertise with brands and get rewarded for each survey you complete.</p>
            <Card>
                <CardBody>
                    <SurveyGrid/>
                </CardBody>
            </Card>
        </div>
    )
}

export default RdSurveys
